import { Component, HostBinding } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    //Variables
    currentApplicationVersion = environment.appVersion;
    lisansyenileme:any=localStorage.getItem('lisansyenileme');
    currentDate : Date = new Date();
}
